var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"aff-auth-section",class:{ 'aff-auth-section--signup': _vm.$route.name == 'SignUp' }},[(!_vm.$route.query.embed)?_c('Header'):_vm._e(),_c('div',{staticClass:"aff-scroll-overlay"},[_c('div',{staticClass:"aff-container aff-auth"},[_c('router-view',{on:{"loading":_vm.changeLoading}}),_c('Loading'),_c('Error')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }